<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donation Information
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="livingDonorToDonateTo"
              disabled
              label="Living Donor to Donate to"
            />
          </div>

          <div class="col-2" v-if="livingDonorToDonateTo === 'Pre-selected Recipient'">
            <ADSTextInput
              id="disabled-text"
              v-model="preSelectedRecipient"
              disabled
              label="Preselected Recipient"
            />
          </div>

          <div class="col-2" v-if="livingDonorToDonateTo === 'To be allocated to a Recipient'">
            <ADSTextInput
              v-model="toBeAllocatedToARecipient"
              disabled
              label="To Be Allocated To A Recipient"
            />
          </div> 
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DonationInformationSection",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      livingDonorToDonateTo: this.getLivingDonorToDonateTo( this.patientBundle ),
      preSelectedRecipient: this.getPreSelectedRecipient( this.patientBundle ),
      toBeAllocatedToARecipient: this.getToBeAllocatedToARecipient( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getLivingDonorToDonateTo( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let livingDonorToDonateTo = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#361' ) ) ;
      if( livingDonorToDonateTo && livingDonorToDonateTo[ 0 ] ) {
        return _.get( livingDonorToDonateTo[0], 'resource.component[0].valueString' );  
      } 
      }
    },
    getPreSelectedRecipient( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let preSelectedRecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#362' ) ) ;
      if( preSelectedRecipient && preSelectedRecipient[ 0 ] ) {
        return _.get( preSelectedRecipient[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getToBeAllocatedToARecipient( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let toBeAllocatedToARecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#363' ) ) ;
      if( toBeAllocatedToARecipient && toBeAllocatedToARecipient[ 0 ] ) {
        return _.get( toBeAllocatedToARecipient[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 110px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
  width: 400px;
}

</style>
